import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useChatContext } from 'stream-chat-react'
import { useDesktop } from 'components/core/SplitPanes'

// A thread's place on the chat page: ?cid= is the link the copy-link button
// and Slack inbox threads share, and on a phone the open thread's screen.
export const threadPath = (cid) => `/chat?cid=${encodeURIComponent(cid)}`

// Opens a thread. On a desktop it shows beside the list, as it always has.
// On a phone it covers the list as a history entry, so the back arrow and
// Safari's edge swipe both return to the list; `replace` takes the current
// entry's place instead, as a new channel takes the create page's.
export const useOpenThread = () => {
  const desktop = useDesktop()
  const navigate = useNavigate()
  const { setActiveChannel } = useChatContext()
  return useCallback(
    (channel, { replace = false } = {}) => {
      setActiveChannel(channel)
      if (desktop) navigate('/chat')
      else
        navigate(threadPath(channel.cid), {
          replace,
          state: { pushed: !replace },
        })
    },
    [desktop, navigate, setActiveChannel]
  )
}

// Back from a phone screen to `to`. When the page pushed the screen, a step
// back through history, so its entry isn't left behind for the swipe to
// find again; when a link opened straight onto it, a replace, which never
// leaves the site.
export const useBack = (to) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  return useCallback(
    () => (state?.pushed ? navigate(-1) : navigate(to, { replace: true })),
    [navigate, state, to]
  )
}
